import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { B3Propagator } from '@opentelemetry/propagator-b3';
import { Resource } from '@opentelemetry/resources';
import { BasicTracerProvider, BatchSpanProcessor, } from '@opentelemetry/sdk-trace-base';
let globalTracerProvider;
export const initTracing = (serviceName, traceConfig) => {
    if (globalTracerProvider) {
        console.error('TracerProvider already initialized');
        return;
    }
    globalTracerProvider = new BasicTracerProvider({
        resource: new Resource({
            'service.name': serviceName,
        }),
    });
    const exporter = new OTLPTraceExporter({
        url: traceConfig.url,
    });
    const { flushIntervalMs = 1000, maxQueueSize = 512, maxExportBatchSize = 50, } = traceConfig.flushConfig ?? {};
    const processor = new BatchSpanProcessor(exporter, {
        scheduledDelayMillis: flushIntervalMs,
        maxQueueSize,
        maxExportBatchSize,
    });
    globalTracerProvider.addSpanProcessor(processor);
    globalTracerProvider.register({
        propagator: new B3Propagator(),
    });
};
export const getTracer = (name, version, options) => {
    if (!globalTracerProvider) {
        throw new Error('TracerProvider not initialized');
    }
    return globalTracerProvider.getTracer(name, version, options);
};
export { context as otelContext, trace as otelTrace, propagation } from '@opentelemetry/api';
//# sourceMappingURL=tracing.js.map